import * as SeparatorPrimitive from "@radix-ui/react-separator";
import { cn } from "@scott/ui/client";
import type * as React from "react";

const Separator = ({
  className,
  orientation = "horizontal",
  decorative = true,
  ref,
  ...props
}: React.ComponentPropsWithoutRef<typeof SeparatorPrimitive.Root> & {
  ref?: React.RefObject<React.ElementRef<
    typeof SeparatorPrimitive.Root
  > | null>;
}) => (
  <SeparatorPrimitive.Root
    aria-orientation={decorative ? undefined : orientation}
    // When the separator is not decorative it should expose the correct role and aria-orientation
    // so assistive technologies can identify it. Radix sets role and aria-orientation automatically
    // for non-decorative separators, but we ensure attributes are present for reliability.
    className={cn(
      "shrink-0 bg-border",
      orientation === "horizontal" ? "h-[1px] w-full" : "h-full w-[1px]",
      className
    )}
    decorative={decorative}
    orientation={orientation}
    ref={ref}
    role={decorative ? undefined : "separator"}
    {...props}
  />
);
Separator.displayName = SeparatorPrimitive.Root.displayName;

export { Separator };
